import React, { useState } from 'react'
import PropTypes from 'prop-types'
import { withStyles } from '@material-ui/core/styles'
import styled from 'styled-components'

import Tooltip from '@material-ui/core/Tooltip'
import HelpOutlineIcon from '@material-ui/icons/HelpOutline'
import Grid from '@material-ui/core/Grid'
import Typography from '@material-ui/core/Typography'
import TextField from 'components/atoms/TextField'
import SubmitButton from 'components/atoms/buttons/SubmitButton'
import TableBody from 'components/molecules/TableBody'
import { userColumns } from './index'
import { convertArrayToObject, emailReg } from 'utils/misc'

const styles = theme => ({
  body: {
    height: 300,
    overflowY: 'scroll',
    margin: theme.spacing(3, 0, 1, 0),
    padding: `0 ${theme.spacing(3)}px`,
    borderTop: `1px solid ${theme.palette.background.medium} `,
  },
  header: {
    padding: `${theme.spacing(1)}px ${theme.spacing(3)}px 0 0`
  },
  footer: {
    height: 50,
  },
})

const TextContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  text-align: center;
  padding: 0 20px;
  max-width: 700px;
  height: 180px;
  align-items: center;
  font-weight: bold;
`

const ButtonContainer = styled.div`
  width: 360px;
  display: flex;
  justify-content: space-between; 
`

const StyledHelpIcon = styled(HelpOutlineIcon)`
  color: #AAAAAA;
  margin-left: 15px;
  margin-bottom: 5px;
  align-self: center;
  :hover {
    cursor: pointer;
  }
`

const TitleContainer = styled.div`
  display: flex;
`

const StyledTooltip = styled(props => (
  <Tooltip
    classes={{ popper: props.className, tooltip: 'tooltip' }}
    {...props}
  />
))`
  & .tooltip {
    width: 225px;
    font-size: 14px;
    opacity: 0.9;
    text-align: 'center';
    padding: 16px;
    background-color: #001325;  
  }
`

const StyledTextField = styled(TextField)`
  .MuiFormHelperText-root {
    color: #ff0000;
    bottom: -25px;
}
`

export const Wrapper = styled.div`
  min-width: 700px;
`

const ShareTrapIndividualPopover = ({
  classes,
  onConfirmClick,
  data,
  handleUserInvite,
  traps,
}) => {
  const [isConfirmState, setIsConfirmState] = useState(false)
  const toggleConfirmState = () => setIsConfirmState(!isConfirmState)
  const [tooltipOpen, setTooltipOpen] = useState(false)
  const [selectedUser, setSelectedUser] = useState({})
  const sortedArray = [...traps[data.historyUuid].trapUsers].sort(user => user.state === 'PENDING' && -1)
    const tableData = convertArrayToObject(sortedArray, 'trapUserId')

  const tooltipContent = () => {
    return (  
      <div>
        <Typography gutterBottom>What are trap users?</Typography>
          <Typography>They are Goodnature users that have shared access to this trap.
              They can share in your success by viewing your trap's human kill count and can help keep your trap
              maintained
              by locating your trap and replacing the Co2 and Paste. They can also edit the name and location of your
              trap.
          </Typography>
      </div>
    )
  }
  const [email, setEmail] = useState('')
  const [isEmailValid, setIsEmailValid] = useState(false)
  const [isValidated, setIsValidated] = useState(false)
  const handleBlur = () => {
    setIsValidated(true)
    setIsEmailValid(() => emailReg.test(email))
  }
  const helperText = email.length && !isEmailValid && isValidated ? 'Please enter a valid email address' : ''

  const handleInvite = async () => {
    await handleUserInvite(email, data, () => setEmail(''))
  }

  const handleItemSelect = (rowData) => {
    setSelectedUser({
        name: rowData.fullName, email: rowData.email, trapUserId: rowData.trapUserId, status: rowData.state
    })
    setIsConfirmState(true)
  }

  const handleConfirm = () => {
      onConfirmClick(selectedUser.trapUserId, selectedUser.status)
  }

  return (
    <div className={classes.root}>
      {!isConfirmState ? 
        <Wrapper>
          <TitleContainer>
            <Typography variant="h1" >Share trap with individual</Typography>
            <StyledTooltip
              placement="bottom"
              arrow
              enterDelay={500}
              title={tooltipContent()}
              open={tooltipOpen}
              onOpen={() => setTooltipOpen(true)}
              onClose={() => setTooltipOpen(false)} >
              <StyledHelpIcon />
            </StyledTooltip>
          </TitleContainer>
          <Grid
            container
            justify="space-between"
            alignItems="center"
            className={classes.header}>
            <StyledTextField placeholder="Email address" onBlur={handleBlur} value={email} onChange={val => setEmail(val)} width={300} helperText={helperText} />
            <SubmitButton
              size="medium"
              loading={false}
              color="primary"
              variant="primary"
              onClick={handleInvite}
              disabled={!isEmailValid}>
               Invite
            </SubmitButton>
          </Grid>
          <section className={classes.body}>
            <TableBody 
              noPlaceholder
              columns={userColumns} 
              dataProvider={tableData} 
              onItemSelect={handleItemSelect} 
            />
          </section>
        </Wrapper> :
        <React.Fragment>
          <TextContainer>
            <Typography variant="h1" gutterBottom bold>Remove Trap User</Typography>
            <Typography variant="h4" maxWidth={400} gutterBottom>
              Are you sure you want to remove {selectedUser.fullName ? selectedUser.name : selectedUser.email} from your trap users?
            </Typography>
          </TextContainer>
          <Grid
            container
            justify="center"
            alignItems="center"
            className={classes.footer}>
            <ButtonContainer>
              <SubmitButton
                size="medium"
                loading={false}
                color="primary"
                variant="secondary"
                onClick={toggleConfirmState}>
                Cancel
              </SubmitButton>
              <SubmitButton
                size="medium"
                loading={false}
                color="primary"
                variant="primary"
                onClick={handleConfirm}>
                Confirm
              </SubmitButton>
            </ButtonContainer>
          </Grid>
        </React.Fragment>}
    </div>
  ) 
}

ShareTrapIndividualPopover.propTypes = {
  classes: PropTypes.object,
  onConfirmClick: PropTypes.func,
  data: PropTypes.object,
  handleUserInvite: PropTypes.func,
  traps: PropTypes.object,
}

export default withStyles(styles)(ShareTrapIndividualPopover)



// WEBPACK FOOTER //
// ./src/components/organisms/ShareTrapIndividualPopover/ShareTrapIndividualPopover.js